// PlanningTab.jsx — "what's pending" for the day / week / month, per brand or
// across all brands. Reads /api/admin/flows/planning.

import React, { useCallback, useEffect, useState } from "react";
import { get } from "../../api";

export default function PlanningTab({ brands, brandId, onSelectBrand }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  const load = useCallback(async () => {
    try {
      const qs = brandId ? `?brandId=${encodeURIComponent(brandId)}` : "";
      const r = await get(`/api/admin/flows/planning${qs}`);
      setData((r && r.planning) || null); setErr(null);
    } catch (e) { setErr((e && e.message) || "Failed to load planning"); }
  }, [brandId]);

  useEffect(() => { load(); const id = setInterval(load, 10000); return () => clearInterval(id); }, [load]);

  const card = (label, value, sub, color) => (
    <div style={{ flex: "1 1 130px", border: "1px solid #e5e7eb", borderRadius: 10, padding: "12px 14px", background: "#fff" }}>
      <div style={{ fontSize: 11, color: "#888" }}>{label}</div>
      <div style={{ fontSize: 26, fontWeight: 700, color: color || "#111827" }}>{value}</div>
      {sub && <div style={{ fontSize: 11, color: "#aaa" }}>{sub}</div>}
    </div>
  );

  return (
    <div>
      <div style={{ marginBottom: 12, display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
        <label style={{ fontSize: 13, color: "#555" }}>Brand:</label>
        <select value={brandId || ""} onChange={(e) => onSelectBrand && onSelectBrand(e.target.value || null)} style={{ padding: "5px 8px", border: "1px solid #d1d5db", borderRadius: 6, fontSize: 13 }}>
          <option value="">— All brands (aggregate) —</option>
          {(brands || []).map((b) => <option key={b._id} value={b._id}>{b.name || b._id}</option>)}
        </select>
      </div>
      {err && <div className="alert alert-warning">{err}</div>}
      {!data ? <div style={{ color: "#999", fontSize: 13 }}>Loading…</div> : (
        <>
          <div style={{ fontSize: 13, fontWeight: 700, margin: "6px 0" }}>Scheduled posts coming up</div>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 16 }}>
            {card("Today", data.scheduledPosts.today, "next 24h", "#0F62FE")}
            {card("This week", data.scheduledPosts.week, "next 7 days")}
            {card("This month", data.scheduledPosts.month, "next 30 days")}
          </div>
          <div style={{ fontSize: 13, fontWeight: 700, margin: "6px 0" }}>Pending work</div>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            {card("Draft posts", data.draftPosts, "not yet scheduled", "#d97706")}
            {card("Pending ideas", data.pendingIdeas, "awaiting drafting")}
            {card("Pending articles", data.pendingArticles, "draft / review")}
            {card("Active sequences", data.activeSequences, "email drips running", "#198038")}
          </div>
        </>
      )}
    </div>
  );
}
